import { RigidBody } from '@react-three/rapier'

export default function ShapePlate()
{
    return <>
        <RigidBody 
            type='fixed'
            position={[ 0, 10, -15]}
        >
            <mesh>
                <cylinderGeometry args={[6,6,0.5]} />
                <meshStandardMaterial color='mediumpurple' />
            </mesh>
        </RigidBody>
    </>
}